export const SUCCESS_ANIMATION_DELAY = 3000;
export const ERROR_ANIMATION_DELAY = 5000;
